//packages
import React, { Component } from 'react';
import PropTypes from 'prop-types';

//styles
import './SubmitButton.less'

class SubmitButton extends Component {
    static propTypes = {
        children: PropTypes.oneOfType([
            PropTypes.element,
            PropTypes.array,
            PropTypes.string,
            PropTypes.number,
        ]),

        onClick: PropTypes.func,

        disabled: PropTypes.bool,

        type: PropTypes.string,

        className: PropTypes.string,
    };

    static defaultProps = {
        children: 'Submit',

        onClick: () => null,

        disabled: false,

        type: 'success',

        size: 'big',

        className: ''
    };

    render() {
        const {
            children,
            onClick,
            disabled,
            type,
            size,
            className
        } = this.props;

        return (
            <input
                type="button"
                disabled={disabled}
                value={children}
                onClick={onClick}
                className={`submit-button submit-button-${type} submit-button-${size} ${className} ${disabled ? 'disabled' : ''}`}
            />
        )
    }
}

export default SubmitButton


/** WEBPACK FOOTER **
 ** ./src/components/Buttons/SubmitButton/SubmitButton.js
 **/